export const MESSAGES = {
  EMAIL_NOT_CONFIRM: `Ваш email не подтвержден`,
  EMAIL_CONFIRM: `Ваш email подтвержден`,

  PHONE_NOT_CONFIRM: `Ваш телефон не подтвержден`,
  PHONE_CONFIRM: `Ваш телефон подтвержден`,
};
